module.exports = __webpack_public_path__ + "static/media/electronics.ac0a57c5.svg";